export default __webpack_public_path__ + "static/media/desmond.67a4334d.jpeg";